import * as React from "react";
import { GraphiQL } from "graphiql";
import "graphiql/graphiql.css";
import "./Graphiql.css";

const fetcher = (graphQLParams: any) =>
  fetch(process.env.REACT_APP_API_URL as string, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("sessionId") || ""
    },
    body: JSON.stringify(graphQLParams)
  })
    .then(response => response.json())
    .catch(() => {});

const GraphiQLWrapper = () => <GraphiQL fetcher={fetcher} />;

export default GraphiQLWrapper;
